import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=e2046c9c&scoped=true&"
import script from "./NewCustomer.vue?vue&type=script&lang=js&"
export * from "./NewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=e2046c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2046c9c",
  null
  
)

export default component.exports